import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFrontMenu } from 'store/actions';
import NavbarItem from './NavbarItem';

const Navbar = ({ sideMenuOpen, onToggleMenu }) => {
  const [activeMenu, setActiveMenu] = useState('');
  const [headerClasses, setHeaderClasses] = useState('nav_bar_area');

  const dispatch = useDispatch();
  const frontMenus = useSelector((state) => state.content.frontMenu);

  const handleScroll = () => {
    if (window.innerWidth > 991) {
      const scroll =
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : (
              document.documentElement ||
              document.body.parentNode ||
              document.body
            ).scrollTop;
      if (scroll >= 150) {
        setHeaderClasses('nav_bar_area fixed');
      } else {
        setHeaderClasses('nav_bar_area');
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    dispatch(fetchFrontMenu());
  }, [dispatch]);

  const handleMenuHover = (menuId) => {
    if (window.innerWidth > 991) {
      setActiveMenu(menuId);
    }
  };

  const handleMenuClick = (menuId) => {
    if (window.innerWidth <= 991) {
      if (menuId === activeMenu) {
        setActiveMenu('');
      } else {
        setActiveMenu(menuId);
      }
    }
  };

  return (
    <nav
      className={`${headerClasses} ${sideMenuOpen ? 'show_menu' : ''}`}
      id="navbar_area"
    >
      <div className="container">
        <div className="mobile_menu_head">
          <a href="/" onClick={onToggleMenu} className="close_menu">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version={1.0}
              width="16.000000pt"
              height="16.000000pt"
              viewBox="0 0 16.000000 16.000000"
              preserveAspectRatio="xMidYMid meet"
            >
              <g
                transform="translate(0.000000,16.000000) scale(0.100000,-0.100000)"
                fill="#000000"
                stroke="none"
              >
                <path d="M0 153 c0 -4 14 -22 32 -40 l32 -33 -34 -35 c-44 -45 -30 -59 15 -15 l35 34 35 -34 c45 -44 59 -30 15 15 l-34 35 34 35 c44 45 30 59 -15 15 l-35 -34 -33 32 c-32 31 -47 39 -47 25z" />
              </g>
            </svg>
          </a>
        </div>
        <ul className="menu_list_area">
          {frontMenus && frontMenus.length
            ? frontMenus.map((frontMenu) => {
                return (
                  <NavbarItem
                    key={frontMenu._id}
                    navData={frontMenu}
                    activeMenu={activeMenu}
                    onMenuHover={handleMenuHover}
                    onMenuClick={handleMenuClick}
                  />
                );
              })
            : null}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
